import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CampaignCard = ({ campaign, onPause, onEdit, onViewAnalytics }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success bg-success/10';
      case 'paused':
        return 'text-warning bg-warning/10';
      case 'draft':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return 'Play';
      case 'paused':
        return 'Pause';
      case 'draft':
        return 'FileText';
      default:
        return 'FileText';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-2 hover:elevation-3 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <h3 className="text-lg font-semibold text-foreground">{campaign?.name}</h3>
            <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(campaign?.status)}`}>
              <Icon name={getStatusIcon(campaign?.status)} size={12} />
              <span className="capitalize">{campaign?.status}</span>
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">{campaign?.description}</p>
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <span className="flex items-center space-x-1">
              <Icon name="Users" size={14} />
              <span>{campaign?.enrolledClients} clients</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="Calendar" size={14} />
              <span>Created {campaign?.createdDate}</span>
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onPause(campaign?.id)}
            disabled={campaign?.status === 'draft'}
          >
            <Icon name={campaign?.status === 'active' ? 'Pause' : 'Play'} size={16} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(campaign?.id)}
          >
            <Icon name="Edit" size={16} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onViewAnalytics(campaign?.id)}
          >
            <Icon name="BarChart3" size={16} />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{campaign?.metrics?.deliveryRate}%</div>
          <div className="text-xs text-muted-foreground">Delivery Rate</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{campaign?.metrics?.responseRate}%</div>
          <div className="text-xs text-muted-foreground">Response Rate</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{campaign?.metrics?.conversions}</div>
          <div className="text-xs text-muted-foreground">Conversions</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">${campaign?.metrics?.revenue}</div>
          <div className="text-xs text-muted-foreground">Revenue</div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="Zap" size={14} className="text-primary" />
          <span className="text-sm text-muted-foreground">
            {campaign?.trigger} • {campaign?.messageCount} messages
          </span>
        </div>
        <div className="text-sm text-muted-foreground">
          Last sent: {campaign?.lastSent}
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;